<div class="fields overflow-y-auto">
	<div class="pr-5">
		<router-outlet></router-outlet>
	</div>
</div>
<div class="document">
	<div *ngIf="instrument" class="mb-3">
		<atomic-button-group
			[options]="documentViewOptions"
			[(ngModel)]="documentView"
		></atomic-button-group>
	</div>
	<ng-container *ngIf="documentView === 'payout'">
		<app-container
			type="dark"
			class="flex flex-1 w-full h-full justify-center items-center"
			*ngIf="!latestUploadedFile"
		>
			<div class="flex flex-1 justify-center items-center">
				<app-sale-file-upload
					type="dropzone"
					label="Upload {{
						encumbrance.action === encumbranceActionTypes.REMAIN
							? 'information'
							: 'payout'
					}} statement"
					[saleId]="matterId$ | async"
					[documentName]="fileName"
					[documentType]="fileType"
					[systemTags]="[tag]"
				></app-sale-file-upload>
			</div>
		</app-container>

		<app-matter-url-pdf-viewer
			*ngIf="latestUploadedFile"
			[googleSrcUrl]="latestUploadedFile.url"
			[fileName]="latestUploadedFile.name"
			[fileType]="latestUploadedFile.fileType"
			class="h-full w-full"
			[showDelete]="true"
			(delete)="delete()"
		></app-matter-url-pdf-viewer>
	</ng-container>
	<ng-container *ngIf="documentView === 'charge'">
		<app-matter-url-pdf-viewer
			*ngIf="instrument"
			[googleSrcUrl]="instrument.uploaded_document_path"
			class="h-full w-full"
		></app-matter-url-pdf-viewer>
	</ng-container>
</div>
